<template>
  <div class="wing-layout candelPdf">
    <div id="main-content">
      <!-- new right start-->
      <div class="wrapper">
        <jm-crumbs :crm_id="this.$route.params.crm_id"/>
        <div class="table-agile-info">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane v-for="(item,index) in activeCountries" :key="index" :label="item.name" :name="item.name" :disabled='item.disabled' ></el-tab-pane>
          </el-tabs>
          <!--文案管理基础信息 start-->
          <component
            :is="which_to_show_form"
            :get-data='getScoreData'
          > </component>
          <!--文案管理基础信息 end-->
          <!--流程信息 start-->
          <div class="technological-wapper">
            <component
              :is="which_to_show"
              v-for="(item, index, keys) in processesData"
              :index="index"
              :item="item"
              :key="keys"
              :this-num="item.num"
              @childData="getChild"
              :score-data="ScoreData"
            >
              <div
                class="btn-group"
                slot="btnGroup">
                <el-button
                  type="primary"
                  @click="saveProcesses(false, index)">提交确认</el-button>
                <el-button @click="saveProcesses(true, index)">预览申请流程</el-button>
                <a
                  target="_blank"
                  :href="`/frontend/log/contduct/${item.crm_id}/write`">查看历史操作</a>
              </div>
            </component>
          </div>
          <!--流程信息 end-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import toolbar from '@/components/tool/toolbar.vue';
import { jmDictSelect } from '@/components/tool';
import tableList from '@/components/data/tableList.vue';
import aus from './technological/technological-aus.vue';
import uk from './technological/technological-uk.vue';
import ausForm from './technological/form-aus.vue';
import ukForm from './technological/form-uk.vue';
import materialClouds from '@/pages/student/officials/materialClouds.vue';
import { Validator } from 'vee-validate';
// 澳洲文案基础信息
let getScoreAusData = {
  custom_year: '',
  custom_month: '',
  isukvi: null,
  other_languages_text: '',
  TOEFL: {
    ln_all: '',
    ln_read: '',
    ln_listen: '',
    ln_write: '',
    ln_say: '',
  },
  IELTS: {
    ln_all: '',
    ln_read: '',
    ln_listen: '',
    ln_write: '',
    ln_say: '',
  },
  GRE: {
    ln_all: '',
    ln_read: '',
    ln_listen: '',
    ln_write: '',
  },
  GMAT: {
    ln_all: '',
  }
};
  // 英国文案基础
let getScoreUkData = {
  custom_year: '',
  custom_month: '',
  offer_exam_time: '',
  offer_exam_time_again: '',
  offer_email: '',
  offer_email_pass: '',
  offer_tell_student: null,
  offer_uk_Argue: null,
  argue_beizhu: '',
  IELTS: {
    ln_all: '',
    ln_read: '',
    ln_listen: '',
    ln_write: '',
    ln_say: '',
    isukvi: null
  },
};
export default {
  data() {
    return {
      nowCountries: ['英国', '澳洲'],
      a: '',
      which_to_show: 'jm-uk',
      country: null,
      getScoreUrl: null,
      getProcessesUrl: null,
      getScoreAusData: getScoreAusData,
      getScoreUkData: getScoreUkData,
      getScoreData: null,
      activeCountries: [],
      processesData: null,
      offerId: null,
      childData: [],
      dictCountries: [],
      allData: {
        scores: {}
      },
      activeName: '',
      which_to_show_form: 'jm-ukform',
    };
  },
  methods: {
    handleClick(val) {
      this.whichCountry(val.name);
      this.childData = [];
    },
    getChild(val) {
      if (val.ischange) {
        this.childData[val.thisIndex] = val;
      } else {
        this.childData.push(val);
      }
    },
    isInArray(arr, value) {
      for (let i = 0; i < arr.length; i++) {
        if (value === arr[i]) {
          return true;
        }
      }
      return false;
    },
    saveProcesses(flag, index) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let topdata = this.ScoreData;
          Object.keys(topdata).forEach((variable) => {
            if (typeof topdata[variable] === 'object' && topdata[variable] !== null) {
              this.allData.scores[variable] = topdata[variable];
            } else {
              this.allData[variable] = topdata[variable];
            }
          });
          let changedata = this.childData[index];
          let currentOfferXiafa = changedata.offer_xiafa;
          let offerXiafaArr = [559, 561, 651, 1826, 1828, 1830];
          // 成功/被调剂/被拒绝,检测是否上传offer
          if (this.isInArray(offerXiafaArr, currentOfferXiafa) && changedata.cloudDataEmptyFlag) {
            this.$message.error('请上传offer或者拒信.');
            return;
          }

          Object.keys(changedata).forEach((val) => {
            this.allData[val] = changedata[val];
          });
          this.allData.save_info_see = flag;
          let upUrl = '/index/uk_process/saveProcesses';
          if (this.country === '澳洲') {
            upUrl = '/index/aus_process/saveProcesses';
          }
          this.allData.crm_id = this.$route.params.crm_id;
          this.$http._post({
            url: upUrl,
            data: this.allData
          }).then((data) => {
            if (data.result === 0) {
              if (data.data === '') {
                this.$message.success('保存成功');
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              } else {
                window.open(data.data);
              }
            } else {
              this.$message.error('保存失败');
            }
          });
        } else {
          this.$message.error('语言信息有错误');
        }
      });
    },
    whichCountry(name = '', first = false) {
      if (name !== '') {
        this.country = name;
      }
      if (this.country === '澳洲') {
        this.which_to_show = 'jm-aus';
        this.which_to_show_form = 'jm-ausform';
        this.getScoreData = this.getScoreAusData;
        this.getScoreUrl = `/index/aus_process/getStudentScore/crmid/${this.$route.params.crm_id}`;
        this.getProcessesUrl = `/index/aus_process/getProcesses/crmid/${this.$route.params.crm_id}`;
      } else if (this.country === '英国') {
        this.which_to_show = 'jm-uk';
        this.which_to_show_form = 'jm-ukform';
        this.getScoreData = this.getScoreUkData;
        this.getScoreUrl = `/index/uk_process/getStudentMessage/crmid/${this.$route.params.crm_id}`;
        this.getProcessesUrl = `/index/uk_process/getProcesses/crmid/${this.$route.params.crm_id}`;
      }
      if (name !== '' && !first) {
        this.getStudentScore();
      }
      this.processesData = null;
    },
    getStudentScore(first = false) {
      let getUrl = '';
      if (first) {
        getUrl = `/index/uk_process/getStudentMessage/crmid/${this.$route.params.crm_id}`;
      } else {
        getUrl = this.getScoreUrl;
      }
      this.$http._post({
        url: getUrl,
      }).then((data) => {
        let countries = data.data.custom_active_country;
        if (first) {
          let activeCountries = countries ? countries.split(',') : [];
          let nowCountriesIndex = null;
          this.nowCountries.forEach((item, index) => {
            let i = activeCountries.indexOf(item);
            if (i !== -1) {
              activeCountries.splice(i, 1);
            } else {
              nowCountriesIndex = index;
            }
          });
          if (nowCountriesIndex !== null) {
            this.nowCountries.splice(nowCountriesIndex, 1);
          }
          activeCountries = this.nowCountries.concat(activeCountries);
          activeCountries.forEach((item, index) => {
            if (item === '英国' || item === '澳洲') {
              activeCountries[index] = { name: item, disabled: false };
            } else {
              activeCountries[index] = { name: item, disabled: true };
            }
          });
          this.activeCountries = activeCountries;
          this.country = this.activeCountries[0].name;
        }
        if (this.country === '澳洲') {
          // eslint-disable-next-line no-multi-assign
          this.getScoreData = this.getScoreAusData = data.data;
          this.activeName = this.country;
        } else {
          // eslint-disable-next-line no-multi-assign
          this.getScoreData = this.getScoreUkData = data.data;
          this.activeName = this.country;
        }
        this.whichCountry(this.country, true);
        this.getProcesses();
      });
    },
    getProcesses() {
      this.$http._post({
        url: this.getProcessesUrl,
      }).then((data) => {
        this.processesData = data.data;
        if (data.data.length > 0) {
          this.offerId = data.data[0].offer_id;
        }
      }).catch(() => {
        setTimeout(() => {
          window.history.go(-1);
        }, 1000);
      });
    },
    yanzhaqngAll() {
      // 本页验证信息方法
      const dictionary = {
        zh_CN: {
          messages: {
            required: (field) => { return `请输入${field}`; },
            between: (filed, data) => { return `${filed}应该在${data[0]} 到 ${data[1]}之间`; },
            numeric: (filed) => { return `${filed}只能为整数`; },
            decimal: (filed) => { return `${filed}最多一位小数`; }
          },
          attributes: {
            IELTSALL: '雅思成绩',
            IELTSL: '雅思听力成绩',
            IELTSR: '雅思阅读成绩',
            IELTSW: '雅思写作成绩',
            IELTSS: '雅思口语成绩',
            TOEFLAll: '托业成绩',
            TOEFLL: '托业听力成绩',
            TOEFLS: '托业口语成绩',
            TOEFLW: '托业写作成绩',
            TOEFLR: '托业阅读成绩',
            GRE: 'GRE成绩',
            GRES: 'GRE数学成绩',
            GREY: 'GRE语文成绩',
            GREX: 'GRE写作成绩',
            GMAT: 'GMAT成绩'
          }
        }
      };
      Validator.localize(dictionary);
    }
  },
  mounted() {
    // this.whichCountry();
    this.getStudentScore(true);
    // this.getProcesses();
    // this.yanzhaqngAll();
  },
  components: {
    'jm-crumbs': crumbs, // 面包屑
    'jm-toolbar': toolbar,
    'jm-aus': aus,
    'jm-uk': uk,
    'jm-ausform': ausForm,
    'jm-ukform': ukForm,
    'jm-materialClouds': materialClouds,
    jmDictSelect,
    tableList,
    Validator
  },
  computed: {
    ScoreData() {
      if (this.country === '澳洲') {
        return this.getScoreAusData;
      }
      return this.getScoreUkData;
    },
  },
  created() {
    Validator.extend('testIELTS', {
      // IELTS 小数点1一位切必须是.5
      getMessage: (field) => { return `${field}保留一位且.5`; },
      validate: (value) => {
        if (value % 1 !== 0) {
          let nVal = String(value).split('.');
          return nVal[1].length === 1 && nVal[1] === '5';
        }
        return true;
      }
    });
  },
  watch: {
    //      item: {
    //        handler: function (val) {
    //          this.$emit('childData', val);
    //        },
    //        deep: true
    //      },
  }
};
</script>
<style scoped>
  .btn-group{
    padding: 10px;
    border: 1px solid #ebeef5;
    border-top: none;
    background: #FBFDFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btn-group a{
    line-height: 34px;
    display: block;
    float: left;
    height:34px;
    padding: 0 16px;
    font-size: 14px;
    border-radius: 4px;
    color: #409EFF;
    border: 1px solid #409EFF;
    margin-left: 8px;
  }
  .btn-group:after{
    display: block;
    content: '';
    clear: both;
    opacity:0;
  }
  .box-content-auto:after{
    display: block;
    content: '';
    clear: both;
    opacity:0;
  }
  .box-content-auto{
    display: flex;
    width: 20%;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }
  .errors{
    color: red;
  }
  .wapper:after,.box-content2:after,.yuyan:after{
    display: block;
    content: '';
    clear: both;
    opacity:0;
  }
  .box-content-all{
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .email{
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 6px;
  }
  .yuyan{
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 6px;
  }
  .yuyan .small{
    width: 60px;
  }
  .box-content{
    width: 30%;
    display: block;
    float: left;
    margin-bottom: 10px;
  }
  .box-content2{
    width: 70%;
    float: left;
    margin-bottom: 10px;
  }
  .box-content2>div{
    display: flex;
    align-items: center;
  }
  .box-content3{
    width: 40%;
    float: left;
    margin-bottom: 10px;
  }
  .box-content3>div{
    display: flex;
  }
  .form-title{
    margin-right: 6px;
    white-space: nowrap;
  }
  .basic-title{
    cursor: default;
    margin-left: 0;
  }
  .basic-title em{
    display: inline-block;
    width: auto!important;
    float: left;
    height: 31px;
    font-size: 16px;
    line-height: 28px;
    padding: 0 8px;
    border-bottom: 4px solid #3368fa;
  }

</style>
<style>
  .small>.el-input__inner{
    text-align: center !important;
  }
  .email>.el-input{
    margin-right: 6px;
  }
  .wapper .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .wapper .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .wapper .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .wapper .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
